import SystemLayout from '@/views/layouts/SystemLayout'
import UserDetailPage from '@/views/profile/UserDetailPage'

export default function UserDetail() {
  return (
    <SystemLayout>
      <UserDetailPage />
    </SystemLayout>
  )
}
